var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.label != null ? _c('Label', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _vm.busca ? [_c('VueSelect', {
    ref: _vm.refBusca,
    class: _vm.inputClass,
    attrs: {
      "label": _vm.labelBusca,
      "options": _vm.options,
      "placeholder": _vm.placeholderInField,
      "resetOnOptionsChange": true,
      "disabled": _vm.disabled,
      "value": _vm.value
    },
    on: {
      "input": _vm.handleChange
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._t("options", null, {
          "data": option
        })];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._t("selected", null, {
          "data": option
        })];
      }
    }], null, true)
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")])], 2)] : [_c('VueSelect', {
    ref: _vm.refBusca,
    class: _vm.inputClass,
    attrs: {
      "label": _vm.labelBusca,
      "filterable": _vm.filterable,
      "placeholder": 'Lançar Produto',
      "options": _vm.options,
      "resetOnOptionsChange": true,
      "disabled": _vm.disabled,
      "value": _vm.value
    },
    on: {
      "input": _vm.handleChange,
      "search": _vm.handleSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._t("options", null, {
          "data": option
        })];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._t("selected", null, {
          "data": option
        })];
      }
    }], null, true)
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")])], 2)]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };